<script setup lang="ts">
import { useClaimFormContext } from '../composables/fields'
const props = defineProps<{ name: string }>()

const { isFieldChanged } = useClaimFormContext()
</script>

<template>
  <UFormField v-slot="{ error }" :name="props.name" :ui="{ error: 'sr-only' }">
    <div
      class="has-focus-visible:outline-secondary-800 has-focus-visible:outline has-focus-visible:outline-2 has-focus-visible:-outline-offset-2 relative"
      :class="[
        error && 'bg-error/10 outline-error outline outline-1',
        isFieldChanged(props.name) &&
          'after:bg-primary-300 after:absolute after:right-1 after:top-1 after:size-2 after:rounded-full after:content-[\'\']',
      ]"
      :title="typeof error === 'string' ? error : undefined"
    >
      <slot />
    </div>
  </UFormField>
</template>
